import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { openCTAPrompt } from '../../ctaPrompt/ctaPromptActions'
import CTAPromptTypes from '../../tour/constants/CTAPromptTypes'

class ContextMenuManager extends PureComponent {
    addContextMenu() {
        const { contextMenu, registry } = this.props

        if (contextMenu.get('name')) {
            const Tag = registry.menus[contextMenu.get('name')]
            return <Tag />
        }
    }

    triggerActNow = ({ key, ctrlKey }) => {
        if (key === 'u' && ctrlKey) {
            this.props.triggerActNow()
        }
    }
    componentDidMount() {
        document.addEventListener('keypress', this.triggerActNow)
    }
    componentWillUnmount() {
        document.removeEventListener('keypress', this.triggerActNow)
    }
    render() {
        const { children } = this.props

        return (
            <div>
                {children}
                {this.addContextMenu()}
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    triggerActNow: () => {
        dispatch(
            openCTAPrompt({
                promptType: CTAPromptTypes.ACT_NOW,
            })
        )
    },
})

export default connect(
    mapSelectorsToProps(['contextMenu']),
    mapDispatchToProps
)(ContextMenuManager)
